// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1qYAG{color:#231815;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}._3XC2g{font-size:18px;font-size:1.125rem;line-height:25px;line-height:1.5625rem}._3XC2g,._2xrdl{font-weight:500;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._2xrdl{font-size:16px;font-size:1rem;line-height:20px;line-height:1.25rem}.Reeza{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_1qYAG",
	"large": "_3XC2g",
	"small": "_2xrdl",
	"icon": "Reeza"
};
module.exports = exports;
